<template>
	<div>
		<v-checkbox class="workerCheckboxRole" v-model="checkboxValue" />
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	props: {
		workerId: {
			type: Number,
			default: 1
		},
	},
	data: () => ({
	}),
	computed: {
		checkboxValue: {
			get() {
				if (this.$store.state.workers.selectedWorkerIds.indexOf(this.workerId) !== -1) {
					return true
				}
				return false
			},
			set(value) {
				this.markRole()
			},
		},
	},
	methods: {
		...mapActions({
			setSelectState: 'workers/setSelectState'
		}),
		markRole() {
			this.setSelectState({
				workerId: this.workerId,
				value: !this.checkboxValue
			})
		}
	},
}
</script>

<style>
.workerCheckboxRole .v-input__slot {
	margin: 5px 0 0 0 !important;
}

.workerCheckboxRole .v-input--selection-controls__input {
	margin: 0 auto;
}
</style>
